import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Outstanding Change Impacts by Priority',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Outstanding Change Impacts by Priority',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Outstanding Impacts',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'High',
                                  y: {
                                    '#': {
                                      '@': 'highPriorityOutstandingImpacts',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Medium',
                                  y: {
                                    '#': {
                                      '@': 'mediumPriorityOutstandingImpacts',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Low',
                                  y: {
                                    '#': {
                                      '@': 'lowPriorityOutstandingImpacts',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                  xLabel: 'Priority',
                  yLabel: 'Outstanding Impacts',
                },
              },
            ],
          },
          type: 'bar',
        },
      },
    },
  },
  subqueries: {
    lowPriorityOutstandingImpacts: {
      filter: {
        and: [
          {
            '!=': [
              {
                '@.': '!status',
              },
              'Complete',
            ],
          },
          {
            '=': [
              {
                '@.': '!priority',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highPriorityOutstandingImpacts: {
      filter: {
        and: [
          {
            '!=': [
              {
                '@.': '!status',
              },
              'Complete',
            ],
          },
          {
            '=': [
              {
                '@.': '!priority',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumPriorityOutstandingImpacts: {
      filter: {
        and: [
          {
            '!=': [
              {
                '@.': '!status',
              },
              'Complete',
            ],
          },
          {
            '=': [
              {
                '@.': '!priority',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
  },
}
